'use client'

import { ReactNode, useMemo } from 'react'
import { AppRouterCacheProvider } from '@mui/material-nextjs/v15-appRouter'
import { CacheProvider } from '@emotion/react'
import { prefixer } from 'stylis'
import rtlPlugin from 'stylis-plugin-rtl'
import createCache from '@emotion/cache'
import ThemeProvider from './theme-provider'

export default function MUIRegistry({ children, direction }: { children: ReactNode; direction: 'rtl' | 'ltr' }) {
    // Create emotion cache for RTL support
    const emotionCache = useMemo(() => {
        switch (direction) {
            case 'rtl':
                return createCache({
                    key: 'muirtl',
                    stylisPlugins: [prefixer, rtlPlugin]
                })
            case 'ltr':
                return createCache({
                    key: 'muiltr',
                    stylisPlugins: [prefixer]
                })
            default:
                return createCache({
                    key: 'muiltr',
                    stylisPlugins: [prefixer]
                })
        }
    }, [])

    return (
        <AppRouterCacheProvider>
            <CacheProvider value={emotionCache}>
                <ThemeProvider direction={direction}>{children}</ThemeProvider>
            </CacheProvider>
        </AppRouterCacheProvider>
    )
}
